import React, { useState, useEffect, useRef } from "react";
import { useHistory, useLocation } from "react-router-dom";
import {
  Box,
  Typography,
  Button,
  TextField,
  Modal,
  Paper,
} from "@mui/material";

import CommonTablePagination from "../CommonTablePagination";
import DocumentMasterTable from "./DocumentMasterTable";
import useHttp from "../../../Hooks/use-http";
import AddNewDocumentMaster from "./AddNewDocumentMaster";
import { PAGINATIONBASEVALUE } from "../../../Constant";
import PortalTitle from "../../CommonComponent/PortalTitle";

// Sample DocumentMaster Data
const DOCUMENTS_DATA = [
  {
    id: 1,
    document_id: "DOC001",
    country: "USA",
    name: "Driver License",
    category: "ID",
    has_expired: false,
    required: true,
    verify_id: "V1234",
    type: "Personal",
  },
  {
    id: 2,
    document_id: "DOC002",
    country: "India",
    name: "Passport",
    category: "ID",
    has_expired: true,
    required: true,
    verify_id: "V5678",
    type: "Official",
  },
  // Add more documents as needed
];

const DOCUMENT_HEADERS = [
  "ID",
  "Country",
  "Name",
  "Note",
  "Category",
  "Expired",
  "Required",
  "Verify ID",
  "Verify Req.",
  "Type",
];

const DocumentMaster = () => {
  const [filteredData, setFilteredData] = useState(DOCUMENTS_DATA); // Use static data initially
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(PAGINATIONBASEVALUE);
  const searchInputRef = useRef();
  const history = useHistory();
  const [openModal, setOpenModal] = useState(false);
  const [isRefresh, setIsRefresh] = useState(false);
  const [dataLoaded, setDataLoaded] = useState(false);

  const handleOpenModal = () => setOpenModal(true);
  const handleCloseModal = () => setOpenModal(false);

  const handleAddDocument = (newDocument) => {
    // Logic to add the new document (e.g., update state or make API call)
  };

  const { isLoading, sendRequest } = useHttp();
  const search = useLocation().search;
  // const id = new URLSearchParams(search).get("corporateId");

  const authenticateUser = (data) => {
    let document_data = [];
    if (data?.documentMaster) {
      for (let i = 0; i < data?.documentMaster.length; i++) {
        document_data.push({
          // id: data.DocumentList[i].documentID,
          document_id: data.documentMaster[i].documentID,
          country: data.documentMaster[i].country,
          note: data.documentMaster[i].documentNote,
          name: data.documentMaster[i].documentName,
          category: data.documentMaster[i].category,
          has_expired: data.documentMaster[i].hasExpired,
          required: data.documentMaster[i].required,
          verify_id: data.documentMaster[i].verifyID,
          verification_required: data.documentMaster[i].verificationRequired,

          type: data.documentMaster[i].type,
          document_note: data.documentMaster[i].documentNote,
        });
      }
    }
    setFilteredData(document_data);
  };

  useEffect(() => {
    // Skip API call, just use static data for now
    // if(isRefresh){
    sendRequest(
      {
        url: "/documentsmaster",
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: {
          emailID: localStorage.getItem("user"),
          // corporateID: id || localStorage.getItem("corpId"),
        },
      },
      authenticateUser
    );
    // setIsRefresh(false);
    // }
    if (!dataLoaded) {
      setDataLoaded(true); // Mark data as loaded after the first API call
    }
  }, [sendRequest, isRefresh, dataLoaded]);

  const nPages = Math.ceil(filteredData.length / rowsPerPage);

  const indexOfLastRecord = page * rowsPerPage + rowsPerPage;
  const indexOfFirstRecord = page * rowsPerPage;
  const currentRecords = filteredData.slice(
    indexOfFirstRecord,
    indexOfLastRecord
  );

  const routeSearchHandler = (e) => {
    setFilteredData(
      DOCUMENTS_DATA.filter(
        (data) =>
          data.document_id
            .toLowerCase()
            .includes(e.target.value.toLowerCase()) ||
          data.country.toLowerCase().includes(e.target.value.toLowerCase()) ||
          data.name.toLowerCase().includes(e.target.value.toLowerCase()) ||
          data.category.toLowerCase().includes(e.target.value.toLowerCase()) ||
          data.type.toLowerCase().includes(e.target.value.toLowerCase())
      )
    );
  };

  return (
    <Box className="document-master">
      <Box
        sx={{
          width: "100%",
          display: "flex",
          flexDirection: "column",
        }}
      >
        <Paper
          sx={{
            width: "100%",
            mb: 2,
            borderRadius: "10px",
            flex: 1,
            display: "flex",
            flexDirection: "column",
            border: "none",
            borderBottom: "none",
          }}
        >
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              px: 2,
              pt: 1,
              pb: 1,
              borderRadius: "10px",
              flexDirection: { xs: "column", md: "row" },
              gap: { xs: 1, md: 0 },
            }}
          >
            <Box component="h2" sx={{ m: 0, display: "flex", alignItems: "center" }}>
              <PortalTitle fallback="Document Master" />
            </Box>
            <Box
              sx={{
                display: "flex",
                gap: "12px",
                alignItems: "center",
                flexDirection: { xs: "column", md: "row" },
              }}
            >
              <Button
                variant="contained"
                size="medium"
                onClick={handleOpenModal}
                sx={{
                  backgroundColor: "#44B150",
                  ":hover": {
                    backgroundColor: "#44B150",
                    opacity: 0.8,
                  },
                  boxShadow: "none",
                  fontFamily: "Montserrat",
                  fontSize: "12px",
                  padding: "8px 20px",
                  textTransform: "none",
                  minWidth: "110px",
                  marginLeft: "12px",
                }}
              >
                Add Document
              </Button>
            </Box>
          </Box>
          <DocumentMasterTable
            data={currentRecords}
            headers={DOCUMENT_HEADERS}
            isLoading={isLoading}
          />
          <Box
            sx={{
              position: "sticky",
              bottom: 0,
              background: "white",
              zIndex: 1,
              border: "none !important",
              borderTop: "none !important",
              borderBottom: "none !important",
            }}
          >
            <CommonTablePagination
              page={page}
              rowsPerPage={rowsPerPage}
              setRowsPerPage={setRowsPerPage}
              setPage={setPage}
              filteredData={filteredData}
              styling={{
                display: "flex",
                justifyContent: "flex-end",
                border: "none",
                borderTop: "none",
                borderBottom: "none",
                "& .MuiTablePagination-root": {
                  border: "none",
                  borderTop: "none",
                  borderBottom: "none",
                },
                "& .MuiTablePagination-toolbar": {
                  border: "none",
                  borderTop: "none",
                  borderBottom: "none",
                },
              }}
            />
          </Box>
        </Paper>
      </Box>

      <Modal
        open={openModal}
        // onClose={handleCloseAddTaskModal}
        onClose={(event, reason) => {
          if (reason !== "backdropClick") {
            handleCloseModal();
          }
        }}
        aria-labelledby="add-new-task-modal"
        aria-describedby="add-new-task-modal-description"
      >
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            overflowX: "hidden",
            transform: "translate(-50%, -50%)",
            width: "50%",
            maxHeight: "80vh",
            overflowY: "hidden",
            bgcolor: "background.paper",
            // bgcolor: "rgba(34, 137, 203, 255)",
            // border: "2px solid",
            zIndex: "1500",
            boxShadow: 24,
            borderRadius: 4,
            p: 3,
          }}
        >
          <Box
            sx={{
              position: "absolute",
              top: 8,
              right: 8,
            }}
          >
            <Button
              onClick={handleCloseModal}
              sx={{
                fontSize: "20px",
                color: "#d52029",
                minWidth: "auto",
                padding: "4px 8px",
                "&:hover": {
                  backgroundColor: "rgba(213, 32, 41, 0.1)",
                },
              }}
            >
              x
            </Button>
          </Box>
          <AddNewDocumentMaster
            open={openModal}
            onClose={handleCloseModal}
            isRefresh={setIsRefresh}
          />
        </Box>
      </Modal>
    </Box>
  );
};

export default DocumentMaster;
